import { mergeArrays } from "./modules/utils";

const PlannerBenchmarkTypePolicy = {
  PlannerBenchmark: {
    fields: {
      levels: {
        merge: mergeArrays,
      },
    },
  },
};

export default PlannerBenchmarkTypePolicy;
